import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { RootState } from '../types'; // 假设这是你的根 State 类型

// 1. 定义这个模块的状态类型
export interface HomeState {
  printerModel: string | null;
}

// 2. 定义 state
//    初始值设为 null，表示还没有选择
export const state: HomeState = {
  printerModel: null
};

// 3. 定义 mutations
//    这是唯一可以修改 state 的地方
export const mutations: MutationTree<HomeState> = {
  /**
   * 设置打印机型号
   * @param state - 当前模块的 state
   * @param {string | null} model - 新的打印机型号
   */
  SET_PRINTER_MODEL(state: HomeState, model: string | null) {
    state.printerModel = model;
  }
};

// 4. 定义 actions
//    组件应该调用这个 action 来更新状态
export const actions: ActionTree<HomeState, RootState> = {
  /**
   * 更新打印机型号
   * @param {function} commit - 用于提交 mutation
   * @param {string | null} model - 从组件传递过来的新型号
   */
  setPrinterModel({ commit }, model: string | null) {
    commit('SET_PRINTER_MODEL', model);
  }
};

// 5. （可选但推荐）定义 getters
//     方便组件获取状态
export const getters: GetterTree<HomeState, RootState> = {
  currentPrinterModel: (state: HomeState) => state.printerModel
};

const namespaced: boolean = true;

export const equipment: Module<HomeState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters // 加上 getters
};
